const localizedWorkDaysStringByLanguage = {
	de: "Werktage",
	pl: "dni robocze",
	en: "workdays",
}
const localizedWeekStringByLanguage = {
	de: "Wochen",
	pl: "tygodnie",
	en: "weeks",
}

const getNumberOfWeeksString = (deliveryTimeWorkDays: number, language) => {
	const localizedWeekString =
		localizedWeekStringByLanguage[language] ?? localizedWeekStringByLanguage.de
	const numberOfWeeks = Math.ceil(deliveryTimeWorkDays / 5)

	if (deliveryTimeWorkDays % 5 === 0) {
		const oneWeekMore = numberOfWeeks + 1

		const deliveryTimeWorkDaysString = `${numberOfWeeks} - ${oneWeekMore} ${localizedWeekString}`

		if (deliveryTimeWorkDays >= 100)
			return `Vorbestellbar - lieferbar in ca. ${deliveryTimeWorkDaysString}`

		return `${numberOfWeeks} - ${oneWeekMore} ${localizedWeekString}`
	}

	const oneWeekLess = numberOfWeeks - 1

	const deliveryTimeWorkDaysString = `${oneWeekLess} - ${numberOfWeeks} ${localizedWeekString}`

	if (deliveryTimeWorkDays >= 100)
		return `Vorbestellbar - lieferbar in ca. ${deliveryTimeWorkDaysString}`
	return deliveryTimeWorkDaysString
}

const getDeliveryTimeWorkDaysString = (deliveryTimeWorkDays: number, language = "de") => {
	const localizedWorkDaysString =
		localizedWorkDaysStringByLanguage[language] ?? localizedWorkDaysStringByLanguage.de
	const actualDeliveryTimeWorkDays = Math.ceil(deliveryTimeWorkDays)

	if (actualDeliveryTimeWorkDays === 0) return `0 ${localizedWorkDaysString}`
	if (actualDeliveryTimeWorkDays === 1) return `1 - 2 ${localizedWorkDaysString}`
	if (actualDeliveryTimeWorkDays > 5)
		return getNumberOfWeeksString(actualDeliveryTimeWorkDays, language)

	const oneDayLess = actualDeliveryTimeWorkDays - 1

	return `${oneDayLess} - ${actualDeliveryTimeWorkDays} ${localizedWorkDaysString}`
}

export default getDeliveryTimeWorkDaysString
